import blogsData from './blogs.json';
export const blogContent = blogsData as any;
